import { loadUrlPromise } from '~/utils/third-party-loader.utils';

interface MaxmindResponse {
    country: {
        iso_code: string;
        names?: {
            en: string;
        };
        geoname_id?: number;
    };
}

// Define the shape of the geoip2 API
interface Geoip2 {
    country: (
        success: (response: MaxmindResponse) => void,
        error: (error: Error) => void
    ) => void;
}

// Private module variable
const maxmindPromise = loadUrlPromise<Geoip2>(
    'https://geoip-js.com/js/apis/geoip2/v2.1/geoip2.js',
    () => (window as any).geoip2 as Geoip2,
    'maxmind-script'
);

/**
 * Gets the country code from Maxmind geolocation service
 * @returns Promise that resolves to the country code in lowercase or null if not available
 */
export async function getCountryCodeFromMaxmind(): Promise<string | boolean> {
    const geoip2 = await maxmindPromise;

    return new Promise<string | null>(resolve => {
        geoip2.country(
            response => {
                if (response.country && response.country.iso_code) {
                    resolve(response.country.iso_code.toLowerCase());
                } else {
                    resolve(null);
                }
            },
            () => {
                // On error, resolve with null
                resolve(null);
            }
        );
    });
}
